import {omit, difference, keys, keyBy, createReducer} from 'helpers';
import {RootState, Actions} from 'store/types';
import {upsertProject, removeProject} from '../actions/goals';
import {ServerActions} from 'store/server';

const actions = {upsertProject, removeProject};

export const types = createReducer<RootState['goals']['types'], Actions<typeof actions> | ServerActions>({}, {
  GOALS_SET_PROJECT: (state, action) => {
    return {
      ...state,
      [action.project.id]: action.project
    }
  },

  GOALS_DELETE_PROJECT: (state, action) => {
    return omit(state, action.id);
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.goalTypes);
    if (action.goalTypes.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.goalTypes, 'id'),
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: () => ({}),
});
